import type { RefObject } from "react";
import { createContext, useContext } from "react";

// Passes the right-hand block settings inner surface ref so nested UIs can portal overlays into it.
// Consumers outside SettingsOverlay see null from useBlockSettingsSurfaceOptional (safe no-op).

export type BlockSettingsSurfaceContextValue = {
  layoutSurfaceRef: RefObject<HTMLDivElement | null>;
};

const BlockSettingsSurfaceContext = createContext<BlockSettingsSurfaceContextValue | null>(
  null
);

export function BlockSettingsSurfaceProvider({
  children,
  value,
}: {
  children: React.ReactNode;
  value: BlockSettingsSurfaceContextValue;
}) {
  return (
    <BlockSettingsSurfaceContext.Provider value={value}>
      {children}
    </BlockSettingsSurfaceContext.Provider>
  );
}

export function useBlockSettingsSurfaceOptional() {
  return useContext(BlockSettingsSurfaceContext);
}
